import React, { useState, useEffect, useRef } from "react";
import Modal from "react-bootstrap/Modal";
import AuthApi from "../../../service/AuthApi";
import { pushNotification } from "../../../utils/notifications";
import { setToken, getToken } from "utils/cookieExtension";
import { setTokenGlobal, setBaseURL, setTokenBase } from "service/common";

export const ModalXacThucDangNhap = (props) => {
  const componentRef = useRef();
  const [data, setData] = useState({});
  useEffect(() => {
    setData(props.data);
  }, []);
  const SetThongTinLogin = (token) => {
    setToken("userInfo", "token=" + token);
    setToken("tokenMorman", token);
    setTokenBase(token, window.endPoint);
  };
  const XacThucDangNhap = async () => {
    if (typeof data.MaXacThuc === "undefined" || data.MaXacThuc.length < 6) {
      pushNotification(
        "Vui lòng nhập đúng mã xác thực.",
        "error",
        "TOP_CENTER",
        3000
      );
    }
    const response = await AuthApi.login(data);
    if (response && response.status === 200) {
      if (response.data.linkNew == 1) {
        SetThongTinLogin(response.data.token);
        setTimeout(() => {
          window.location.href = response.data.RedirectUrl;
        }, 2000);
      } else {
        SetThongTinLogin(response.data.token);
        setTimeout(() => {
          window.location.href = response.data.RedirectUrl;
        }, 2000);
      }
    } else {
      const errorMessage =
        response?.data?.message ||
        response?.data ||
        "Đăng nhập thất bại. Vui lòng thử lại hoặc liên hệ hỗ trợ.";
      pushNotification(errorMessage, "error", "TOP_CENTER", 3000);
    }
  };
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setData((prev) => ({ ...prev, [name]: value }));
  };
  return (
    <Modal
      {...props}
      size="modal-dialog"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="fade modal-new modal fade text-left modal show"
      backdrop="static"
    >
      <Modal.Header>
        <h4 className="modal-title" id="myModalLabel16">
          <span className="btn-icon-right">
            <i className="mdi mdi-qrcode"></i>
          </span>
          Xác thực đăng nhập
        </h4>
        <button
          type="button"
          className="close-popup-new"
          onClick={props.onHide}
        >
          <i className="mdi mdi-close"></i>
        </button>
      </Modal.Header>
      <Modal.Body>
        <div className="form-group row">
          <label className="col-md-12 label-control">
            Bạn đang đăng nhập trên thiết bị có IP chưa được phép đăng nhập. Vui
            lòng liên hệ quản lý để lấy mã xác nhận.
          </label>
        </div>
        <div className="col-lg-12 text-center">
          <input
            type="text"
            value={data.MaXacThuc}
            placeholder="NHẬP MÃ XÁC THỰC"
            maxLength={6}
            className="cssMaDangNhap"
            onChange={handleInputChange}
            name="MaXacThuc"
          />
        </div>
      </Modal.Body>
      <Modal.Footer className="modal-footer">
        <button
          type="button"
          class="btn btn-new-main btn-closenew"
          href={() => false}
          onClick={props.onHide}
        >
          <span>
            <i class="mdi mdi-close"></i>
          </span>
          &nbsp; Đóng &nbsp;
        </button>
        <button
          className="btn btn-new-main btn-checknew"
          type="submit"
          onClick={XacThucDangNhap}
        >
          <span>
            <img src="/app-assets/images/icon-save-v2-white.png" />
          </span>
          Xác nhận
        </button>
      </Modal.Footer>
    </Modal>
  );
};
